import { useMediaQuery } from '@material-ui/core'
import React from 'react'
import { BadgeVariant } from 'core/elements/badge/Badge'
import { getConsoleEndpoint } from '../../vms/actions'
import PowerVirtualMachineDialog from '../../vms/PowerVirtualMachineDialog'
import { cpuImagePath, memoryImagePath, storageImagePath } from './constant'

// import { networkDebugDoc } from 'app/docLinks'

type AppDetail = {
  status: string
  upgradeState: string
  [key: string]: any // to allow other props
}

type FilterItem = {
  label: string
  value: string
}

export const appStatus = {
  Running: 'success',
  Error: 'error',
  Stopped: 'warning',
  Starting: 'warning',
  Pending: 'warning',
  Unknown: 'unknown',
  Rejected: 'error',
  Default: 'default',
  active: 'success',
  deployed: 'success',
  failed: 'error',
  'delete failed': 'error',
  deleting: 'warning',
  deploying: 'warning',
  stopped: 'error',
  suspended: 'warning',
} as const

export const appLableMap = {
  Running: 'Running',
  Error: 'Error',
  Stopped: 'Stopped',
  Starting: 'Starting',
  Pending: 'Pending',
  Unknown: 'Unknown',
  Rejected: 'Rejected',
  active: 'Active',
  deployed: 'Deployed',
  failed: 'Failed',
  'delete failed': 'Delete Failed',
  deleting: 'Deleting',
  deploying: 'Deploying',
  stopped: 'Stopped',
  suspended: 'Suspended',
}

export const capitalize = (str) => {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

export const statusList = Object.keys(appLableMap).map((key) => ({
  label: appLableMap[key],
  value: key.toLowerCase(),
}))
const getUniqueList = (appDetails: any[], key: string): { label: string; value: string }[] => {
  return [
    ...new Set(appDetails?.flatMap((item) => (item?.[key] ? [item[key]?.toLowerCase()] : []))),
  ]?.map((value: string) => ({
    label: capitalize(value),
    value,
  }))
}

export const getOwnerList = (appDetails) => getUniqueList(appDetails, 'ownerName')
export const getVersionList = (appDetails) => getUniqueList(appDetails, 'version')
export const getStateList = (appDetails) => getUniqueList(appDetails, 'status')

export const versionsList = [
  {
    label: 'Stable Only',
    value: 'stable',
  },
  {
    label: 'Upgrade Available',
    value: 'upgrade',
  },
]

export const getAppStatus = (phase: string) => {
  const status: BadgeVariant = appStatus[phase] || 'unknown'
  const label = appLableMap[phase] || phase
  return { variant: status, label }
}

export const splitByIsShared = (arr) => {
  const shared = []
  const nonShared = []

  for (const item of arr) {
    ;(item?.isShared ? shared : nonShared)?.push(item)
  }

  return [shared, nonShared]
}

export const overviewActions = (item, setShowVmsModal, setRowData) => ({
  rightActions: [
    //Commenting as we are not going to implement it for june release but will be implemented later
    // {
    //   label: 'Upgrade Available',
    //   icon: 'chevrons-up',
    //   onClick: () => {},
    // },
    {
      label: 'Manage VMs',
      icon: 'list',
      tooltipFn: () => 'Manage VMs',
      onClick: () => {
        setRowData(item)
        setShowVmsModal(true)
      },
    },
    //Commenting as we are not going to implement it for june release but will be implemented later
    // {
    //   label: '',
    //   icon: 'terminal',
    //   tooltipFn: () => 'Console',
    //   disabledFn: (vmi) => {
    //     // return loadingClusters || loadingServices || !service
    //     return false
    //   },
    //   // Todo: What if theres more than 1 port?
    //   // externalLink: `http://${cluster?.masterIp}:${service?.ports?.[0]?.nodePort}/vnc_lite.html?path=k8s/apis/subresources.kubevirt.io/v1/namespaces/${vmi?.namespace}/virtualmachineinstances/${vmi?.name}/vnc`,
    //   externalLink: networkDebugDoc,
    // },
  ],
  //Commenting as we are not going to implement it for june release but will be implemented later
  // leftActions: [
  //   {
  //     label: 'Stop',
  //     icon: 'stop',
  //     tooltipFn: () => 'Stop',
  //     // DialogComponent: VmiPowerOperationDialog,
  //     // refreshFn: reloadVmis,
  //     hideFn: () => item?.status !== 'Running',
  //     customDialogProps: {
  //       params: {
  //         operation: 'stop',
  //       },
  //     },
  //   },
  //   {
  //     label: 'Resume',
  //     icon: 'play',
  //     tooltipFn: () => 'Resume',
  //     // DialogComponent: VmiPowerOperationDialog,
  //     // refreshFn: reloadVmis,
  //     hideFn: () => item?.status === 'Running',
  //     customDialogProps: {
  //       params: {
  //         operation: 'resume',
  //       },
  //     },
  //   },
  //   {
  //     label: 'Reboot',
  //     icon: 'sync',
  //     tooltipFn: () => 'Reboot',
  //     // onClick: reloadVmis,
  //     onClick: () => {},
  //   },
  //   {
  //     label: 'Suspend',
  //     icon: 'pause',
  //     tooltipFn: () => 'Suspend',
  //     // DialogComponent: VmiPowerOperationDialog,
  //     // refreshFn: reloadVmis,
  //     hideFn: (vmi) => !!vmi?.paused,
  //     customDialogProps: {
  //       params: {
  //         operation: 'suspend',
  //       },
  //     },
  //   },
  //   {
  //     label: 'Start',
  //     icon: 'circular-play',
  //     tooltipFn: () => 'Start',
  //     // DialogComponent: VmiPowerOperationDialog,
  //     // refreshFn: reloadVmis,
  //     hideFn: (vmi) => !vmi?.paused,
  //     customDialogProps: {
  //       params: {
  //         operation: 'start',
  //       },
  //     },
  //   },
  // ],
})

export const vmsActions = (item, reload) => ({
  leftActions: [
    {
      label: '',
      icon: 'stop',
      tooltipFn: () => 'Stop',
      DialogComponent: (props) => (
        <PowerVirtualMachineDialog
          {...props}
          rows={[item]}
          action={'stop'}
          onClose={(isSuccess) => isSuccess && reload(true)}
        />
      ),
      hideFn: () => item?.status !== 'active',
      customDialogProps: {
        params: {
          operation: 'stop',
        },
      },
    },
    {
      label: '',
      icon: 'circle-play',
      tooltipFn: () => 'Start',
      DialogComponent: (props) => (
        <PowerVirtualMachineDialog
          {...props}
          rows={[item]}
          action={'start'}
          onClose={(isSuccess) => isSuccess && reload(true)}
        />
      ),
      hideFn: () => item?.status === 'active',
      customDialogProps: {
        params: {
          operation: 'start',
        },
      },
    },
    {
      label: '',
      icon: 'sync',
      tooltipFn: () => 'Reboot',
      DialogComponent: (props) => (
        <PowerVirtualMachineDialog
          {...props}
          rows={[item]}
          action={'reboot'}
          onClose={(isSuccess) => isSuccess && reload(true)}
        />
      ),
      hideFn: () => item?.status !== 'active',
    },
    {
      label: '',
      icon: 'terminal',
      tooltipFn: () => 'Console',
      onClick: () => {
        const openConsole = async () => {
          const url = await getConsoleEndpoint({ id: item?.id })
          const withVmName = `${url}&instance=${item?.name || item?.id}`
          window.open(withVmName)
        }
        openConsole()
      },
    },
  ],
})
export const allAppActions = (item, setShowVmsModal, setRowData) => ({
  rightActions: [
    // {
    //   label: 'Clone',
    //   icon: 'files',
    //   tooltipFn: () => 'Clone',
    //   //  DialogComponent: VmiPowerOperationDialog,
    //   addRoute: routeManager.routes.openstack.createApps,
    //   // disabledFn: (vmi) => {
    //   //   // return loadingClusters || loadingServices || !service
    //   //   return false
    //   // },
    //   // Todo: What if theres more than 1 port?
    //   // externalLink: `http://${cluster?.masterIp}:${service?.ports?.[0]?.nodePort}/vnc_lite.html?path=k8s/apis/subresources.kubevirt.io/v1/namespaces/${vmi?.namespace}/virtualmachineinstances/${vmi?.name}/vnc`,
    //   externalLink: networkDebugDoc,
    //   onClick: () => {
    //     setRowData(item)
    //     setShowVmsModal(true)
    //   },
    // },
  ],
  leftActions: [
    // {
    //   label: 'Clone',
    //   icon: 'files',
    // }
  ],
})

export function filterAppsByStateAndVersion(
  apps: AppDetail[],
  selectedState: FilterItem[] = [],
  selectedVersion: FilterItem[] = [],
): AppDetail[] {
  return apps?.filter((app) => {
    const statusMatch =
      selectedState?.length === 0 ||
      selectedState?.some((state) => state?.value?.toLowerCase() === app?.status?.toLowerCase())

    const versionMatch =
      selectedVersion?.length === 0 ||
      selectedVersion?.some(
        (version) => version?.value?.toLowerCase() === app?.upgradeState?.toLowerCase(),
      )

    return statusMatch && versionMatch
  })
}

export const toReadOnlyKeyValueEntries = (dataArray, keyField, valueField) =>
  dataArray?.map((item) => ({
    key: item[keyField],
    value: item[valueField],
    disabledKey: true,
    disabledValue: true,
    shouldNotShowDelete: true,
  }))

export function filterAppsByOwnerAndVersion(
  apps: AppDetail[],
  selectedOwner?: FilterItem[],
  selectedVersion?: FilterItem[],
): AppDetail[] {
  return apps?.filter((app) => {
    const versionMatch =
      selectedVersion?.length === 0 ||
      selectedVersion?.some(
        (version) => version?.value?.toLowerCase() === app?.version?.toLowerCase(),
      )

    const ownerMatch =
      selectedOwner?.length === 0 ||
      selectedOwner?.some((owner) => owner?.value?.toLowerCase() === app?.ownerName.toLowerCase())

    return versionMatch && ownerMatch
  })
}

export const useBreakpointMatch = (maxWidthPx: number) => {
  return useMediaQuery(`(max-width:${maxWidthPx}px)`)
}

export const getTemplateRequestBody = (params) => {
  return {
    name: params?.name || '',
    description: params?.description || '',
    repo_id: params?.repoId || '',
    repo_source: {
      branch: params?.tag || 'main',
      path: params?.terraformModulePath || '',
    },
    variables: (params?.variables || [])?.map(({ key, value, sensitive }) => ({
      key,
      value,
      sensitive,
    })),
    icon: params?.icon, // assuming no icon in defaultParams
  }
}

export const getFetchModuleRequestBody = (params) => {
  return {
    repo_id: params?.repoId || '',
    repo_source: {
      branch: params?.tag || 'main',
      path: params?.terraformModulePath || '',
    },
  }
}

export const getAppRequestBody = (params) => {
  return {
    name: params?.name || '',
    description: params?.description || '',
    template_id: params?.templateId || '',
  }
}

export const toBase64 = async (input: File | string): Promise<string> => {
  const fileToDataURL = (file: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()

      reader.onloadend = () => {
        const result = reader.result
        if (typeof result === 'string') {
          resolve(result)
        } else {
          reject(new Error('Could not convert to base64'))
        }
      }

      reader.onerror = () => reject(new Error('FileReader failed'))

      reader.readAsDataURL(file)
    })
  }

  try {
    if (typeof input === 'string') {
      const response = await fetch(input)
      if (!response.ok) {
        throw new Error(`Failed to fetch URL: ${input}`)
      }
      const blob = await response.blob()
      return await fileToDataURL(blob)
    } else {
      return await fileToDataURL(input)
    }
  } catch (error) {
    throw error
  }
}

export const getResourceDetails = (data, showLastDivider = false) => [
  {
    label: 'CPUs',
    value: data?.totalVcpus,
    imagePath: cpuImagePath,
    showDivider: true,
  },
  {
    label: 'Storage',
    value: `${data?.totalDisk} GB`,
    imagePath: storageImagePath,
    showDivider: true,
  },
  {
    label: 'Memory',
    value: `${data?.totalRam} GB`,
    imagePath: memoryImagePath,
    showDivider: showLastDivider,
  },
]

export const stripAnsiCodes = (input: string): string => input.replace(/\u001b\[[0-9;]*m/g, '')

export const getVariablesDetails = (variables = []) =>
  variables
    ?.map((item) => ({
      key: item?.name,
      value: item?.default?.toString() || '',
      disabledKey: true,
      shouldNotShowDelete: item?.default === null,
      sensitive: item?.sensitive,
    }))
    ?.sort((a, b) => Number(b.value === '') - Number(a.value === ''))
